module.exports = __webpack_public_path__ + "static/media/25588002_1703510613057456_4144364879343107948_o.b7e21b06.jpg";